import React, { useEffect } from 'react';
import { SiLine } from 'react-icons/si'; // 從 react-icons 庫導入 LINE 圖標
import './LineLoginButton.css';
import { apiPath, API_VERSION } from '../../constants';
import { getCookieToken } from '../../constants/apiList/apiToken';

const LineLoginButton = () => {
    // const clientId = '1656023937';
    const clientId =  process.env.REACT_APP_LINE_ID;
    const redirectUri = apiPath.GET_URL_LINELOGINAUTH;
    // const scope = 'profile openid email';
    const scope = 'profile openid';

    const handleLogin = async () => {
        const token = await getCookieToken();

        // webType: dev => 192.168.0,16 Yao's development.
        // webType: test => rtmart.v7idea.com Testing environment
        // webType: self => localhost:3000
        // webType: production => https://fukuro-api.10parking.com
        
        const data = {
            'token': token,
            'webType': 'production',
            'callback': '/memberProfile',//默認引導到會員中心
            'DeviceType': 'web',
            'AppName': '順康Web',
            'AppVersionNo': API_VERSION,
        }
        const state = encodeURIComponent(JSON.stringify(data)); // 需要生成一個唯一的狀態字符串來防止 CSRF 攻擊
        const lineLoginUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&state=${state}&scope=${scope}`;
        window.location.href = lineLoginUrl;
    };

    return (
        <button className="line-login-button" onClick={handleLogin}>
            <SiLine className="line-logo" /> LINE 登入
        </button>
    );
};

export default LineLoginButton;